import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { ContentSubtype } from "../types/ContentSubtype";

export const renderContentSubtype = <T>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): ReactElement | null => {
    return renderEnumValue(ContentSubtype, item, _index, column);
};
